import { useContext } from 'react';
import NotificationContext from './notification-context';

export default function useNotification() {
  return useContext(NotificationContext);
}
